/* Digital Rollup Startseite: Bühne, Konfigurator, Inhalte, Angebot als PDF */
(() => {
  // Produktdaten kommen aus Shopify (Abschnitt „DR Konfigurator“).
  // /cart/<variante>:<menge> legt die Menge in den Warenkorb und öffnet direkt die Kasse.
  const CFG = (() => { try { return JSON.parse(document.getElementById('dr-config').textContent); } catch (e) { return null; } })();
  const SHOP = CFG ? CFG.shop : location.origin;
  const CASE_VARIANT = CFG && CFG.caseVariant ? String(CFG.caseVariant) : '';
  // Ausführungen (1.9 und, wenn das Produkt existiert, 1.5). M ist die gewählte.
  const MODELS = CFG && CFG.models && CFG.models.length ? CFG.models : [{
    key: '1.9', name: 'Digital Rollup', variant: CFG ? CFG.variant : '', price: CFG ? CFG.price : 2690,
    pitch: '1,95', pxW: 256, pxH: 1024, nits: 'bis 1.000', sheet: '',
  }];
  let M = MODELS[0];
  // Preisstaffel und Flightcases (snippets/dr-staffel.liquid): ab 2 und ab 6 Geräten gilt ein günstigerer Preis
  // für alle Geräte der Bestellung. Jedes Gerät kommt im Flightcase: Doppelcases, bei ungerader Anzahl ein Einzelcase.
  const STAFFEL = (() => { try { return JSON.parse(document.getElementById('dr-staffel').textContent); } catch (e) { return null; } })();
  const tiersOf = (key) => (STAFFEL && STAFFEL[key] && STAFFEL[key].tiers) || null;
  const unitPrice = (key, qty, fallback) => {
    const t = tiersOf(key);
    if (!t) return fallback;
    let p = t[0][1];
    t.forEach(([min, pr]) => { if (qty >= min) p = pr; });
    return p;
  };
  const caseSplit = (qty) => ({ d: Math.floor(qty / 2), e: qty % 2 });
  const caseText = (qty) => {
    const { d, e } = caseSplit(qty);
    const parts = [];
    if (d) parts.push(d + '\u00a0' + (d === 1 ? 'Doppelcase' : 'Doppelcases'));
    if (e) parts.push('1\u00a0Einzelcase');
    return parts.join(' + ');
  };
  // „Im Preis ist 1 Einzelcase … enthalten“, bei mehreren Cases „sind … enthalten“
  const inclText = (qty) => {
    const { d, e } = caseSplit(qty);
    return 'Im Preis ' + (d + e > 1 || d > 1 ? 'sind ' : 'ist ') + '<b>' + caseText(qty) + '</b> für den Transport enthalten. ';
  };
  const caseCart = (qty) => {
    const { d, e } = caseSplit(qty);
    const c2 = STAFFEL && STAFFEL.case2, c1 = STAFFEL && STAFFEL.case1;
    return (c2 && d ? ',' + c2 + ':' + d : '') + (c1 && e ? ',' + c1 + ':' + e : '');
  };
  const cartUrl = (qty) => SHOP + '/cart/' + M.variant + ':' + qty + caseCart(qty);
  // Beim 1.5 lassen sich nur 5 Displays direkt verbinden, darüber braucht es einen externen Controller.
  // Bestellen bleibt möglich, der Hinweis gilt nur für den Fall, dass alle Displays zu einer Wand verbunden werden sollen.
  const needsController = (key, qty) => !!(STAFFEL && STAFFEL[key] && STAFFEL[key].direct && qty > STAFFEL[key].direct);
  const controllerHtml = () => ((STAFFEL && STAFFEL.controllerNote) || '') + ' <a href="/pages/contact?thema=Angebot">Controller anfragen</a>';
  const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const designMode = !!(window.Shopify && window.Shopify.designMode);
  const WALL_MAX = 8;   // so viele lassen sich zu einer Wand verbinden
  const QTY_MAX = 99;   // so viele lassen sich bestellen

  const UNIT_W = 50, X0 = 90, SCREEN_Y = 36, SCREEN_H = 200, BASE_Y = 236;

  const USES = {
    1: '<b>Ein Display</b> eignet sich zum Beispiel für den Eingang, das Schaufenster oder den Empfang.',
    2: 'Mit <b>zwei Displays</b> gestalten Sie Aktionsflächen im Laden.',
    3: 'Ab <b>drei Displays</b> entsteht eine kleine Bildwand für Showroom oder Messestand.',
    5: 'Ab <b>fünf Displays</b> haben Sie eine große Bildwand für Messe, Veranstaltung oder Foyer.',
  };

  // Kurzes Etikett im Maßstabsbild, passend zu USES
  const TAGS = { 1: 'Für Eingang und Empfang', 2: 'Für Aktionsflächen', 3: 'Für Showroom und Messestand', 5: 'Für Messe und Foyer' };

  const euro = (v) => v.toLocaleString('de-DE') + '\u00a0€';
  const num = (v) => v.toLocaleString('de-DE');
  const px = (w, h) => num(w) + '\u00a0×\u00a0' + num(h) + '\u00a0Pixel';
  const dec = (v) => v.toLocaleString('de-DE', { minimumFractionDigits: 1, maximumFractionDigits: 1 });
  const $ = (id) => document.getElementById(id);
  const svgNS = 'http://www.w3.org/2000/svg';

  if ($('count')) {
  // Trennlinien zwischen den Displays: kurz sichtbar nach dem Verbinden, danach ist es ein Bild
  const seamLines = [];
  for (let k = 1; k < WALL_MAX; k++) {
    const l = document.createElementNS(svgNS, 'line');
    l.setAttribute('x1', X0 + k * UNIT_W); l.setAttribute('x2', X0 + k * UNIT_W);
    l.setAttribute('y1', SCREEN_Y); l.setAttribute('y2', SCREEN_Y + SCREEN_H);
    l.style.display = 'none';
    $('seams').appendChild(l); seamLines.push(l);
  }
  let seamTimer = 0;
  function flashSeams(wall) {
    seamLines.forEach((l, i) => { l.style.display = i + 1 < wall ? '' : 'none'; l.classList.remove('gone'); });
    clearTimeout(seamTimer);
    seamTimer = setTimeout(() => seamLines.forEach((l) => l.classList.add('gone')), 60);
  }

  let n = 1;
  let shown = 1; // animierter Wert für die Grafik

  // Auswahlknöpfe 1–8, darüber hinaus Eingabefeld
  const count = $('count');
  for (let i = 1; i <= WALL_MAX; i++) {
    const b = document.createElement('button');
    b.type = 'button';
    b.textContent = i;
    b.setAttribute('aria-label', i === 1 ? '1 Display' : i + ' Displays');
    b.addEventListener('click', () => set(i));
    count.appendChild(b);
  }
  count.addEventListener('keydown', (e) => {
    if (e.key === 'ArrowRight' || e.key === 'ArrowUp') { e.preventDefault(); set(Math.min(WALL_MAX, n + 1), true); }
    if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') { e.preventDefault(); set(Math.max(1, n - 1), true); }
  });

  const stepper = $('stepper'), qty = $('qty');
  $('moreLink').addEventListener('click', () => {
    stepper.hidden = false; $('moreLink').hidden = true;
    set(Math.max(n, WALL_MAX + 1)); qty.focus();
  });
  $('minus').addEventListener('click', () => set(n - 1));
  $('plus').addEventListener('click', () => set(n + 1));
  qty.addEventListener('change', () => set(parseInt(qty.value, 10) || 1));

  const plural = (k) => (k === 1 ? '1 Display' : k + ' Displays');

  function set(v, focus) {
    n = Math.max(1, Math.min(QTY_MAX, v));
    qty.value = n;
    [...count.children].forEach((b, i) => {
      b.setAttribute('aria-pressed', i + 1 === n);
      b.tabIndex = i + 1 === n ? 0 : -1;
      if (focus && i + 1 === n) b.focus();
    });
    const wall = Math.min(n, WALL_MAX);
    if (n <= WALL_MAX) {
      // Bis 8 Displays kein Beispielsatz: Etikett über dem Bild und Bildfläche sagen dasselbe
      $('use').innerHTML = '';
      $('use').hidden = true;
      const tagUse = $('stageUse');
      if (tagUse) tagUse.textContent = TAGS[Object.keys(TAGS).map(Number).filter((k) => k <= wall).pop()];
    } else {
      $('use').hidden = false;
      const full = Math.floor(n / WALL_MAX), rest = n % WALL_MAX;
      const walls = full === 1 ? 'eine Wand aus 8' : full + ' Wände aus je 8';
      const tail = rest === 0 ? '' : rest === 1 ? ' und ein einzelnes Display' : ' und eine aus ' + rest;
      $('use').innerHTML = '<b>' + n + ' Displays</b>. Zu einer Wand verbinden lassen sich jeweils bis zu 8, Sie können also zum Beispiel ' + walls + tail + ' aufstellen.';
    }
    const fmt = $('fmtText');
    if (fmt) fmt.textContent = wall === 1
      ? 'Ein Display zeigt ' + px(M.pxW, M.pxH) + ' im Hochformat.'
      : 'Ihre Wand aus ' + wall + ' Displays zeigt ' + px(M.pxW * wall, M.pxH) + '. Ein einzelnes Display zeigt ' + px(M.pxW, M.pxH) + '.';
    $('extra').hidden = n <= WALL_MAX;
    $('extra').textContent = '+ ' + plural(n - WALL_MAX);

    $('fAreaLabel').textContent = n <= WALL_MAX ? 'Bildfläche' : 'Größte Wand';
    $('fArea').textContent = dec(wall * 0.5) + '\u00a0×\u00a02,0\u00a0m';
    $('fRes').textContent = px(M.pxW * wall, M.pxH);

    const special = (STAFFEL && STAFFEL.special) || '/pages/contact';
    $('incl').innerHTML = inclText(n)
      + 'Sie möchten für jedes Display ein eigenes Flightcase? <a href="' + special + '">Angebot anfragen</a>';

    const unit = unitPrice(M.key, n, M.price);
    const total = n * unit;
    tweenSum(total);
    $('calc').textContent = n + '\u00a0×\u00a0' + euro(unit);
    renderTiers();
    const label = plural(n);
    const ctrl = needsController(M.key, n);
    const cn = $('ctrlNote');
    if (cn) { cn.hidden = !ctrl; cn.innerHTML = ctrl ? controllerHtml() : ''; }
    $('buyText').textContent = label + ' bestellen';
    $('barCount').textContent = label;
    const url = cartUrl(n);
    $('buy').href = url;
    $('barBuy').href = url;

    animate();
    powerOn(wall);
    syncAd();
  }

  // Gesamtpreis zählt kurz zum neuen Wert
  var sumShown = null, sumRaf = 0;
  function tweenSum(to) {
    const from = sumShown == null ? to : sumShown;
    cancelAnimationFrame(sumRaf);
    const show = (v) => { const s = euro(v); $('sum').textContent = s; $('barSum').textContent = s; };
    if (reduceMotion || from === to) { sumShown = to; show(to); return; }
    const t0 = performance.now(), dur = 380;
    const step = (t) => {
      const p = Math.min(1, (t - t0) / dur), e = 1 - Math.pow(1 - p, 3);
      sumShown = p < 1 ? Math.round(from + (to - from) * e) : to;
      show(sumShown);
      if (p < 1) sumRaf = requestAnimationFrame(step);
    };
    sumRaf = requestAnimationFrame(step);
  }

  // Staffel unter der Anzahl: 1 / 2–5 / ab 6 Displays, die gerade gültige Stufe ist hervorgehoben
  function renderTiers() {
    const box = $('tiers'), t = tiersOf(M.key);
    if (!box) return;
    if (!t) { box.hidden = true; return; }
    box.hidden = false;
    box.innerHTML = t.map(([min, pr], i) => {
      const next = t[i + 1];
      const label = !next ? 'ab ' + min + ' Displays' : next[0] - 1 === min ? (min === 1 ? '1 Display' : min + ' Displays') : min + '–' + (next[0] - 1) + ' Displays';
      const on = n >= min && (!next || n < next[0]);
      return '<div' + (on ? ' class="on"' : '') + '><small>' + label + '</small><b>' + (i ? 'je ' : '') + euro(pr) + '</b></div>';
    }).join('');
  }

  // Neue Displays schalten sich ein wie echte LED-Displays: erst schwarz, dann wird die ganze Fläche hell
  // und der Rand leuchtet kurz auf. Beim Motivwechsel wird das Bild nur kurz dunkler, ohne Randleuchten.
  const power = $('powerOn');
  let litWall = 1;
  const ledCurve = (l) => { const t = Math.max(0, Math.min(1, (l - 0.08) / 0.92)); return 1 - Math.pow(1 - t, 3); };
  function addDark(k) {
    const x = X0 + k * UNIT_W;
    const g = document.createElementNS(svgNS, 'g');
    g.dataset.k = k;
    g.innerHTML =
      `<rect x="${x}" y="${SCREEN_Y}" width="${UNIT_W}" height="${SCREEN_H}" fill="#151519"/>` +
      `<rect x="${x + 1}" y="${SCREEN_Y + 1}" width="${UNIT_W - 2}" height="${SCREEN_H - 2}" fill="none" stroke="#ffd6ec" stroke-width="2" filter="url(#cfgEdge)" opacity="0"/>`;
    power.appendChild(g);
    return g;
  }
  function scan(g, delay, depth = 1) {
    const rect = g.firstChild, edge = g.lastChild;
    const t0 = performance.now() + delay, dur = depth < 1 ? 420 : 600;
    rect.setAttribute('opacity', depth);
    const step = (t) => {
      if (!g.isConnected) return;
      const p = Math.max(0, Math.min(1, (t - t0) / dur));
      rect.setAttribute('opacity', (depth * (1 - ledCurve(p))).toFixed(3));
      edge.setAttribute('opacity', depth < 1 ? 0 : (Math.sin(Math.PI * p) * 0.85).toFixed(3));
      if (p < 1) requestAnimationFrame(step); else g.remove();
    };
    requestAnimationFrame(step);
  }
  function powerOn(wall) {
    if (wall !== litWall) flashSeams(wall);
    [...power.children].forEach((g) => { if (+g.dataset.k >= wall) g.remove(); });
    if (!reduceMotion && wall > litWall) {
      for (let k = litWall; k < wall; k++) scan(addDark(k), 240 + (k - litWall) * 80);
    }
    litWall = wall;
  }

  // Werbemotive: wechseln sich ab, der Wechsel läuft mit der Einschalt-Linie. Ohne Motive bleibt das Logo.
  var AD = null, AD_BG = null, ADS = null, adStep = 0, adTimer = 0;
  // Seitenverhältnis (Höhe : Breite) der Motive, sobald sie geladen sind
  const adRatio = {};
  // Bei 2 Displays steht diese Stelle des Wandmotivs (Anteil der Breite, dort ist die Person) in der Mitte
  const AD_FOCUS_2 = 0.36;
  const adPool = () => (Math.min(n, WALL_MAX) === 1 || !ADS.quer.length ? ADS.hoch : ADS.quer);
  // Lage des Motivs: normal genau auf der Bildfläche, bei 2 Displays größer und so verschoben, dass die Person mittig steht
  function layoutAd(W) {
    if (!AD) return;
    const src = AD.getAttribute('href'), r = adRatio[src];
    if (Math.min(n, WALL_MAX) === 2 && ADS && ADS.quer.length && r && r < 1) {
      const area = 2 * UNIT_W, iw = SCREEN_H / r;
      const x = Math.min(X0, Math.max(X0 + area - iw, X0 + area / 2 - iw * AD_FOCUS_2));
      AD.setAttribute('x', x); AD.setAttribute('width', iw);
    } else {
      AD.setAttribute('x', X0); AD.setAttribute('width', W);
    }
  }
  function showAd(src) {
    if (!AD) return;
    const wall = Math.min(n, WALL_MAX);
    if (src) { AD.setAttribute('href', src); AD_BG.setAttribute('href', src); }
    // Ein Display (1:4): schlanke Motive (ab etwa 1:3,4) füllen es ganz aus, an den Seiten fällt nur ein
    // schmaler Rand weg. Breitere Motive stehen in voller Breite oben, darunter eine unscharfe Fortsetzung.
    // Ab 2 Displays das Wandmotiv über alle Displays: bis 5 links (Person), ab 6 rechts (Schrift).
    const fill = wall === 1 && (adRatio[src] || 0) >= 3.4;
    const fade = wall === 1 && !fill;
    AD.setAttribute('preserveAspectRatio', fade ? 'xMidYMin meet' : wall <= 2 ? 'xMidYMid slice' : wall <= 5 ? 'xMinYMid slice' : 'xMaxYMid slice');
    if (fade) AD.setAttribute('mask', 'url(#adFade)'); else AD.removeAttribute('mask');
    AD.setAttribute('opacity', src ? 1 : 0);
    AD_BG.setAttribute('opacity', src && fade ? 1 : 0);
    layoutAd(shown * UNIT_W);
    $('logoEl').setAttribute('opacity', src ? 0 : 1);
  }
  function syncAd() {
    if (!ADS) return;
    const pool = adPool();
    if (!pool.length) { adStep = 0; showAd(''); return; }
    if (adStep < 1 || adStep > pool.length) adStep = 1;
    showAd(pool[adStep - 1]);
  }
  function nextAd() {
    const pool = adPool();
    if (pool.length < 2) return;
    adStep = (adStep % pool.length) + 1;
    showAd(pool[adStep - 1]);
    for (let k = 0; k < litWall; k++) scan(addDark(k), k * 70, 0.85);
  }
  (() => {
    AD = $('adEl'); AD_BG = $('adBg');
    if (!AD || !AD_BG) return;
    const list = (s) => (s || '').split('|').filter(Boolean);
    ADS = { hoch: list(CFG && CFG.adsHoch), quer: list(CFG && CFG.adsQuer) };
    if (!(ADS.hoch.length || ADS.quer.length)) { ADS = null; return; }
    [...ADS.hoch, ...ADS.quer].forEach((s) => {
      const i = new Image();
      i.onload = () => { adRatio[s] = i.naturalHeight / i.naturalWidth; if (AD.getAttribute('href') === s) syncAd(); };
      i.src = s;
    });
    syncAd();
    if (reduceMotion) return;
    new IntersectionObserver((es) => {
      clearInterval(adTimer);
      if (es[0].isIntersecting) adTimer = setInterval(nextAd, 4200);
    }, { threshold: 0.4 }).observe($('scene'));
  })();

  // Grafik: Bildfläche wächst weich mit
  let raf = 0;
  function animate() {
    cancelAnimationFrame(raf);
    const from = shown, to = Math.min(n, WALL_MAX), t0 = performance.now();
    const dur = matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 420;
    const step = (t) => {
      const p = dur ? Math.min(1, (t - t0) / dur) : 1;
      const e = 1 - Math.pow(1 - p, 3);
      shown = from + (to - from) * e;
      draw(shown);
      if (p < 1) raf = requestAnimationFrame(step);
    };
    raf = requestAnimationFrame(step);
  }

  function draw(u) {
    const W = u * UNIT_W;
    for (const id of ['screenEl', 'glossEl', 'adBg', 'clipRect']) { const el = $(id); if (el) el.setAttribute('width', W); }
    layoutAd(W);
    // Logo mit Rahmen ist hochkant (2 : 3)
    let lw = Math.min(W * 0.62, 26 + W * 0.2), lh = lw * 1.5;
    if (lh > SCREEN_H * 0.62) { lh = SCREEN_H * 0.62; lw = lh / 1.5; }
    const logo = $('logoEl');
    logo.setAttribute('width', lw); logo.setAttribute('height', lh);
    logo.setAttribute('x', X0 + W / 2 - lw / 2);
    logo.setAttribute('y', SCREEN_Y + SCREEN_H / 2 - lh / 2);

    const units = Math.ceil(u - 0.001);
    // Standfuß mit Rollen je Display
    const bases = $('bases'); bases.replaceChildren();
    for (let k = 0; k < units; k++) {
      const x = X0 + k * UNIT_W;
      const vis = k < Math.min(n, WALL_MAX) ? 1 : Math.max(0, Math.min(1, u - k));
      const g = document.createElementNS(svgNS, 'g');
      g.setAttribute('opacity', vis);
      if (vis < 1) g.setAttribute('transform', 'translate(' + ((1 - vis) * 36).toFixed(1) + ' 0)');
      g.innerHTML =
        `<rect x="${x + 3}" y="${BASE_Y}" width="${UNIT_W - 6}" height="7" rx="1.5" fill="#1d1d1f"/>` +
        `<rect x="${x + 21}" y="${BASE_Y - 2}" width="8" height="3" fill="#2b2b2e"/>` +
        `<circle cx="${x + 8}" cy="${BASE_Y + 10}" r="3.4" fill="#2b2b2e"/>` +
        `<circle cx="${x + UNIT_W - 8}" cy="${BASE_Y + 10}" r="3.4" fill="#2b2b2e"/>`;
      bases.appendChild(g);
    }
    const sh = $('shadowEl');
    sh.setAttribute('cx', X0 + W / 2); sh.setAttribute('rx', W / 2 + 14);

    // Breitenmaß
    $('dimWLine').setAttribute('x2', X0 + W);
    $('dimWR').setAttribute('x1', X0 + W); $('dimWR').setAttribute('x2', X0 + W);
    $('dimWText').setAttribute('x', X0 + W / 2);
    $('dimWText').textContent = dec(Math.round(u) * 0.5) + ' m';
  }

  // Auswahl der Ausführung (nur wenn es zwei gibt)
  const modelBtns = [...document.querySelectorAll('#models [data-model]')];
  let modelReady = false;
  const setModel = (key, focus) => {
    M = MODELS.find((m) => m.key === key) || MODELS[0];
    modelBtns.forEach((b) => {
      const on = b.dataset.model === M.key;
      b.setAttribute('aria-checked', on ? 'true' : 'false');
      b.tabIndex = on ? 0 : -1;
      if (on && focus) b.focus();
    });
    const sheet = $('sheetLink');
    if (sheet && M.sheet) sheet.href = M.sheet;
    // Farbe und Schild im Maßstabsbild folgen der Ausführung
    const cfgBox = document.querySelector('.config.has-models');
    if (cfgBox) cfgBox.dataset.model = M.key;
    const tag = $('stageModel');
    if (tag) tag.textContent = 'Digital Rollup ' + M.pitch + '\u00a0mm Pixelabstand';
    if (typeof n !== 'undefined') set(n);
    if (modelReady && !reduceMotion) for (let k = 0; k < litWall; k++) scan(addDark(k), k * 70);
    modelReady = true;
  };
  modelBtns.forEach((b, i) => {
    b.addEventListener('click', () => setModel(b.dataset.model));
    b.addEventListener('keydown', (e) => {
      if (['ArrowRight', 'ArrowDown', 'ArrowLeft', 'ArrowUp'].includes(e.key)) {
        e.preventDefault();
        const next = modelBtns[(i + (e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : modelBtns.length - 1)) % modelBtns.length];
        setModel(next.dataset.model, true);
      }
    });
  });

  // Preis an den Auswahlknöpfen aus der Staffel (Preis für 1 Display)
  modelBtns.forEach((b) => { const t = tiersOf(b.dataset.model), em = b.querySelector('em'); if (t && em) em.textContent = euro(t[0][1]); });

  // Startwerte aus der Adresse, z. B. /?modell=1.5&anzahl=2#konfigurieren (Links von den Produktseiten)
  const params = new URLSearchParams(location.search);
  const wanted = (params.get('modell') || '').replace(',', '.');
  if (MODELS.some((m) => m.key === wanted)) setModel(wanted);
  else setModel(MODELS[0].key);
  const start = Math.max(1, Math.min(QTY_MAX, parseInt(params.get('anzahl'), 10) || 1));
  if (start > WALL_MAX) { stepper.hidden = false; $('moreLink').hidden = true; }
  set(start);
  // Von der Produktseite: ?pdf=1 öffnet gleich das Fenster für das Angebot als PDF
  if (params.get('pdf') === '1') setTimeout(() => $('quoteBtn') && $('quoteBtn').click(), 600);
  if (reduceMotion) $('scene').pauseAnimations();

  // Angebot als PDF (jsPDF wird erst beim ersten Klick geladen)
  const COMPANY = {
    name: 'Emotive Systems GmbH',
    street: 'Hohenloher Weg 44',
    city: '33102 Paderborn',
    phone: '+49 5251 544 91 91',
    mail: 'info@digital-rollup.de',
    web: 'digital-rollup.de',
    register: 'Amtsgericht Paderborn, HRB 12339',
    vat: 'USt-IdNr. DE305749988',
    contact: 'Dennis Glaser, Vertriebsleiter',
  };
  const LOGO_URL = 'https://digital-rollup.de/cdn/shop/files/digital_rollup_LOGO_wordmark_2025_1c_black.svg?v=1747301251';
  const money = (v) => v.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';

  let jsPdfReady;
  function loadJsPdf() {
    jsPdfReady ??= new Promise((ok, fail) => {
      const sc = document.createElement('script');
      sc.src = (window.DR_ASSETS && window.DR_ASSETS.jspdf) || 'https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js';
      sc.onload = () => ok(window.jspdf.jsPDF);
      sc.onerror = fail;
      document.head.appendChild(sc);
    });
    return jsPdfReady;
  }

  async function logoPng() {
    const svg = await fetch(LOGO_URL).then((r) => r.text());
    const url = URL.createObjectURL(new Blob([svg], { type: 'image/svg+xml' }));
    const img = new Image();
    await new Promise((ok, fail) => { img.onload = ok; img.onerror = fail; img.src = url; });
    // als JPEG auf weißem Grund, damit das PDF klein bleibt
    const c = document.createElement('canvas');
    c.width = c.height = 400;
    const x = c.getContext('2d');
    x.fillStyle = '#fff'; x.fillRect(0, 0, 400, 400);
    x.drawImage(img, 0, 0, 400, 400);
    URL.revokeObjectURL(url);
    return c.toDataURL('image/jpeg', 0.92);
  }

  async function makeQuote(qty, firma, name) {
    const [JsPDF, logo] = await Promise.all([loadJsPdf(), logoPng().catch(() => null)]);
    const doc = new JsPDF({ unit: 'mm', format: 'a4' });
    const L = 20, R = 190;
    const ink = [23, 23, 23], grey = [110, 110, 110], line = [220, 220, 224], pink = [217, 59, 146];
    const today = new Date();
    const date = today.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' });

    if (logo) doc.addImage(logo, 'JPEG', L - 1, 12, 26, 26);

    // Absender rechts oben
    doc.setFont('helvetica', 'normal'); doc.setFontSize(8.5); doc.setTextColor(...grey);
    [COMPANY.name, COMPANY.street, COMPANY.city, 'Telefon ' + COMPANY.phone, COMPANY.mail, COMPANY.web]
      .forEach((t, i) => doc.text(t, R, 16 + i * 4.2, { align: 'right' }));

    // Empfänger
    doc.setFontSize(7.5);
    doc.text(COMPANY.name + ', ' + COMPANY.street + ', ' + COMPANY.city, L, 50);
    doc.setDrawColor(...line); doc.line(L, 51.5, L + 85, 51.5);
    doc.setFontSize(10.5); doc.setTextColor(...ink);
    const to = [firma, name ? (firma ? 'z. Hd. ' : '') + name : ''].filter(Boolean);
    to.forEach((t, i) => doc.text(t, L, 58 + i * 5.2));

    // Datum
    doc.setFontSize(9); doc.setTextColor(...grey);
    doc.text('Datum', 150, 58); doc.text('Ihr Ansprechpartner', 150, 68);
    doc.setTextColor(...ink); doc.setFontSize(10);
    doc.text(date, 150, 62.5); doc.text('Dennis Glaser', 150, 72.5);
    doc.setFontSize(9); doc.text(COMPANY.phone, 150, 77);

    // Titel
    doc.setFont('helvetica', 'bold'); doc.setFontSize(20);
    doc.text('Angebot', L, 95);
    doc.setFont('helvetica', 'normal'); doc.setFontSize(10.5); doc.setTextColor(...grey);
    doc.text(M.name + ', ' + (qty === 1 ? '1 Display' : qty + ' Displays'), L, 101.5);

    doc.setTextColor(...ink); doc.setFontSize(10);
    doc.text('Vielen Dank für Ihr Interesse. Gerne bieten wir Ihnen Folgendes an:', L, 112);

    // Tabelle
    let y = 122;
    doc.setFontSize(8.5); doc.setTextColor(...grey);
    doc.text('Pos.', L, y); doc.text('Beschreibung', L + 12, y);
    doc.text('Menge', 128, y, { align: 'right' }); doc.text('Einzelpreis', 157, y, { align: 'right' }); doc.text('Gesamt', R, y, { align: 'right' });
    doc.setDrawColor(...ink); doc.setLineWidth(0.3); doc.line(L, y + 2.5, R, y + 2.5);

    y += 9;
    doc.setTextColor(...ink); doc.setFontSize(10);
    doc.text('1', L, y);
    doc.setFont('helvetica', 'bold'); doc.text(M.name, L + 12, y); doc.setFont('helvetica', 'normal');
    const unit = unitPrice(M.key, qty, M.price);
    doc.text(String(qty), 128, y, { align: 'right' });
    doc.text(money(unit), 157, y, { align: 'right' });
    doc.text(money(qty * unit), R, y, { align: 'right' });
    doc.setFontSize(8.8); doc.setTextColor(...grey);
    const desc = [
      'Mobiles LED-Display für Innenräume, Bildfläche 50 × 200 cm',
      'Pixelabstand ' + M.pitch + ' mm, ' + num(M.pxW) + ' × ' + num(M.pxH) + ' Pixel, Helligkeit ' + M.nits + ' nits',
      'Aluminium-Druckguss, mit Rollen, Steuerung per USB, LAN oder WLAN',
    ];
    if (qty > 1 && qty <= WALL_MAX) desc.push('Zusammen verbunden: Bildfläche ' + dec(qty * 0.5) + ' × 2,0 m, ' + num(M.pxW * qty) + ' × ' + num(M.pxH) + ' Pixel');
    if (qty > WALL_MAX) desc.push('Bis zu 8 Displays lassen sich zu einer Bildfläche von 4,0 × 2,0 m verbinden');
    if (needsController(M.key, qty)) desc.push('Für eine Wand aus mehr als 5 Displays ist ein externer Controller nötig, nach Absprache');
    desc.forEach((t, i) => doc.text(t, L + 12, y + 5 + i * 4.3));
    y += 5 + desc.length * 4.3 + 3;
    doc.setDrawColor(...line); doc.setLineWidth(0.2); doc.line(L, y, R, y);

    // Flightcases sind im Gerätepreis enthalten: Doppelcases, bei ungerader Anzahl zusätzlich ein Einzelcase
    const cs = caseSplit(qty);
    let pos = 2;
    [['Doppelcase', cs.d, 'Flightcase für 2 Displays, ' + ((STAFFEL && STAFFEL.caseSize2) || '')],
     ['Einzelcase', cs.e, 'Flightcase für 1 Display, ' + ((STAFFEL && STAFFEL.caseSize1) || '')]].forEach(([title, cnt, txt]) => {
      if (!cnt) return;
      y += 6;
      doc.setTextColor(...ink); doc.setFontSize(10);
      doc.text(String(pos++), L, y);
      doc.setFont('helvetica', 'bold'); doc.text(title, L + 12, y); doc.setFont('helvetica', 'normal');
      doc.text(String(cnt), 128, y, { align: 'right' });
      doc.text('inklusive', 157, y, { align: 'right' });
      doc.text(money(0), R, y, { align: 'right' });
      doc.setFontSize(8.8); doc.setTextColor(...grey);
      doc.text(txt.replace(/, $/, ''), L + 12, y + 5);
      y += 5 + 4.3 + 3;
      doc.setDrawColor(...line); doc.line(L, y, R, y);
    });

    // Summen
    const net = qty * unit, tax = Math.round(net * 19) / 100;
    y += 7;
    const sumRow = (label, val, bold) => {
      doc.setFont('helvetica', bold ? 'bold' : 'normal'); doc.setFontSize(bold ? 11 : 10);
      doc.setTextColor(...(bold ? ink : grey)); doc.text(label, 130, y);
      doc.setTextColor(...ink); doc.text(val, R, y, { align: 'right' });
      y += 6;
    };
    sumRow('Summe netto', money(net));
    sumRow('zzgl. 19 % MwSt.', money(tax));
    doc.setDrawColor(...ink); doc.setLineWidth(0.3); doc.line(130, y - 3.2, R, y - 3.2);
    y += 1.5;
    sumRow('Gesamtbetrag', money(net + tax), true);

    // Bedingungen
    y += 6;
    doc.setFont('helvetica', 'bold'); doc.setFontSize(10); doc.setTextColor(...ink);
    doc.text('Konditionen', L, y);
    doc.setFont('helvetica', 'normal'); doc.setFontSize(9.2);
    [
      ['Preise', 'Netto pro Display, Mengenpreis ab 2 und ab 6 Displays, Flightcases inklusive'],
      ['Lieferzeit', 'auf Anfrage'],
      ['Versand', 'Zuzüglich Versandkosten, diese werden vor der Bestellung ausgewiesen.'],
      ['Garantie', '2 Jahre Herstellergarantie'],
      ['Kundenkreis', 'Verkauf nur an Geschäftskunden'],
    ].forEach(([k, v], i) => {
      doc.setTextColor(...grey); doc.text(k, L, y + 6 + i * 5.2);
      doc.setTextColor(...ink); doc.text(v, L + 28, y + 6 + i * 5.2);
    });
    y += 6 + 4 * 5.2 + 6;

    // Bestell-Link
    const orderUrl = cartUrl(qty);
    doc.setFillColor(245, 245, 247); doc.roundedRect(L, y, R - L, 22, 3, 3, 'F');
    doc.setFont('helvetica', 'bold'); doc.setFontSize(10.5); doc.setTextColor(...ink);
    doc.text('Direkt online bestellen', L + 6, y + 8.5);
    doc.setFont('helvetica', 'normal'); doc.setFontSize(9.2); doc.setTextColor(...pink);
    doc.textWithLink(qty === 1 ? 'Mit diesem Link liegt 1 Display bereits im Warenkorb' : 'Mit diesem Link liegen ' + qty + ' Displays bereits im Warenkorb', L + 6, y + 15, { url: orderUrl });
    doc.setTextColor(...grey);
    doc.text('Oder rufen Sie uns an: ' + COMPANY.phone, R - 6, y + 8.5, { align: 'right' });

    // Fußzeile
    doc.setDrawColor(...ink); doc.setLineWidth(0.3); doc.line(L, 275, R, 275);
    doc.setFontSize(7.5); doc.setTextColor(...grey);
    doc.text('Dieses Angebot wurde online erstellt.', L, 271);
    doc.text([COMPANY.name, COMPANY.street, COMPANY.city], L, 280);
    doc.text([COMPANY.register, COMPANY.vat], 82, 280);
    doc.text(['Geschäftsführer:', 'Nikita Dohrenkamp, Stephan Gehle'], 142, 280);

    doc.save('Angebot-' + M.name.replace(/\s+/g, '-') + '-' + qty + (qty === 1 ? '-Display' : '-Displays') + '.pdf');
  }

  const dlg = $('quoteDlg');
  $('quoteBtn').addEventListener('click', () => {
    $('qCount').textContent = (MODELS.length > 1 ? M.name + ', ' : '') + plural(n);
    $('qSum').textContent = euro(n * unitPrice(M.key, n, M.price)) + ' netto';
    loadJsPdf();
    dlg.showModal();
    window.lenis?.stop();
  });
  dlg.addEventListener('close', async () => {
    window.lenis?.start();
    if (dlg.returnValue !== 'ok') return;
    const f = $('quoteForm');
    try {
      await makeQuote(n, f.firma.value.trim(), f.name.value.trim());
    } catch (e) {
      alert('Das PDF konnte nicht erstellt werden. Bitte rufen Sie uns an: 05251 544 91 91');
    }
  });

  }

  // Inhalte aufspielen: vier Wege. Die Animation zeigt Schritt für Schritt, was passiert,
  // der passende Schritt links ist dabei hervorgehoben.
  (() => {
    const svg = $('waySvg');
    if (!svg) return;
    const WAYS = JSON.parse(($('dr-ways') || {}).textContent || '{}');
    const defs = svg.querySelector('defs'), holder = $('wDisplays'), cards = $('wCards'), fx = $('wFx');
    const usb = $('wUsb'), app = $('wApp'), pc = $('wPc'), waves = $('wWaves'), cloud = $('wCloud');
    const cursor = $('wCursor'), send = $('wSend'), arrow = $('wArrow'), replay = $('wayReplay');
    const tabs = [...document.querySelectorAll('.ways [role="tab"]')].filter((t) => WAYS[t.dataset.way]);
    if (!tabs.length) return;
    const FIRST = tabs[0].dataset.way;

    // Displays: Inhalt A (Logo) und darüber Inhalt B (Ihre Aktion), der von oben nach unten einläuft
    let clipN = 0;
    const makeDisplay = (x, y, sc) => {
      const cp = document.createElementNS(svgNS, 'clipPath');
      cp.id = 'wClip' + clipN++;
      cp.innerHTML = '<rect x="0" y="0" width="56" height="0"/>';
      defs.appendChild(cp);
      const g = document.createElementNS(svgNS, 'g');
      g.setAttribute('transform', `translate(${x} ${y}) scale(${sc})`);
      g.innerHTML =
        '<rect x="-2" y="-2" width="60" height="228" rx="2" fill="#1d1d1f"/>' +
        '<use href="#wScreenA" width="56" height="224"/>' +
        `<use href="#wScreenB" width="56" height="224" clip-path="url(#${cp.id})"/>` +
        '<line x1="0" x2="56" y1="0" y2="0" stroke="#fff" stroke-width="1.6" opacity="0"/>' +
        '<rect x="-6" y="226" width="68" height="8" rx="2" fill="#1d1d1f"/>' +
        '<circle cx="28" cy="230" r="1.8" fill="#4a4a4f"/>' +
        '<circle cx="4" cy="240" r="4" fill="#2b2b2e"/><circle cx="52" cy="240" r="4" fill="#2b2b2e"/>';
      holder.appendChild(g);
      g._clip = cp.firstChild;
      g._scan = g.querySelector('line');
      g._led = g.querySelectorAll('circle')[0];
      return g;
    };
    const main = makeDisplay(392, 28, 1);
    const sideL = makeDisplay(312, 122, 0.62), sideR = makeDisplay(470, 122, 0.62);
    const screens = [main, sideL, sideR];
    const setB = (g, k) => {
      g._clip.setAttribute('height', 224 * k);
      g._scan.setAttribute('y1', 224 * k); g._scan.setAttribute('y2', 224 * k);
      g._scan.setAttribute('opacity', k > 0 && k < 1 ? 0.95 : 0);
    };
    const led = (g, on) => g._led.setAttribute('fill', on ? '#ff2d8a' : '#4a4a4f');

    // Zeitsteuerung: jeder neue Ablauf bricht den alten ab
    let run = 0;
    const wait = (ms, id) => new Promise((r) => setTimeout(() => r(id === run), ms));
    const ease = (t) => (t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2);
    const tween = (ms, fn, id) => new Promise((done) => {
      const t0 = performance.now();
      const step = (t) => {
        if (id !== run) return done(false);
        const k = Math.min(1, (t - t0) / ms);
        fn(ease(k), k);
        if (k < 1) requestAnimationFrame(step); else done(true);
      };
      requestAnimationFrame(step);
    });
    const scanIn = (g, id) => tween(700, (k) => setB(g, k), id);

    // Bildkarte, die vom Gerät zum Display fliegt
    const card = () => {
      const g = document.createElementNS(svgNS, 'g');
      g.innerHTML = '<rect x="-9" y="-16" width="18" height="32" rx="3" fill="url(#adGrad)"/>' +
        '<circle cx="0" cy="-7" r="4.5" fill="#fff" opacity=".9"/>';
      cards.appendChild(g);
      return g;
    };
    const place = (g, x, y, r = 0, sc = 1, op = 1) => {
      g.setAttribute('transform', `translate(${x.toFixed(1)} ${y.toFixed(1)}) rotate(${r.toFixed(1)}) scale(${sc.toFixed(3)})`);
      g.setAttribute('opacity', op.toFixed(2));
    };
    const fly = (g, a, c, b, ms, id, grow = 0, fade = true) => tween(ms, (k) => {
      const x = (1 - k) * (1 - k) * a[0] + 2 * (1 - k) * k * c[0] + k * k * b[0];
      const y = (1 - k) * (1 - k) * a[1] + 2 * (1 - k) * k * c[1] + k * k * b[1];
      const dx = (1 - k) * (c[0] - a[0]) + k * (b[0] - c[0]);
      const tilt = Math.max(-14, Math.min(14, dx * 0.08)) * Math.sin(Math.PI * k);
      place(g, x, y, tilt, 1 + grow * k, fade ? Math.min(1, (1 - k) / 0.18) : 1);
    }, id);

    // Tippen bzw. Klicken sichtbar machen
    const ripple = (x, y, id) => {
      const c = document.createElementNS(svgNS, 'circle');
      c.setAttribute('cx', x); c.setAttribute('cy', y); c.setAttribute('fill', 'none');
      c.setAttribute('stroke', '#d93b92'); c.setAttribute('stroke-width', 2);
      fx.appendChild(c);
      return tween(500, (k) => { c.setAttribute('r', 3 + 14 * k); c.setAttribute('opacity', 1 - k); }, id).then((ok) => { c.remove(); return ok; });
    };
    const press = (id) => tween(260, (_, k) => {
      const sc = 1 - 0.1 * Math.sin(Math.PI * k);
      send.setAttribute('transform', `translate(50 170) scale(${sc}) translate(-50 -170)`);
    }, id);
    const moveCursor = (from, to, ms, id) => {
      cursor.style.display = '';
      return tween(ms, (k) => cursor.setAttribute('transform', `translate(${from[0] + (to[0] - from[0]) * k} ${from[1] + (to[1] - from[1]) * k})`), id);
    };
    const rise = (el, base, id) => tween(450, (k) => {
      el.setAttribute('transform', `translate(${base[0]} ${base[1] + 14 * (1 - k)})`);
      el.setAttribute('opacity', k);
    }, id);

    const steps = () => [...$('waySteps').children];
    const mark = (i) => steps().forEach((li, j) => {
      li.classList.toggle('is-active', j === i);
      li.classList.toggle('is-done', j < i);
    });

    const PLAY = {
      async usb(id) {
        mark(0);
        const c = card();
        place(c, 113, 150, 0, 0.9, 0);
        if (!(await fly(c, [113, 150], [113, 180], [113, 228], 750, id, -0.6))) return;
        c.remove();
        mark(1);
        if (!(await tween(900, (k) => usb.setAttribute('transform', `translate(${70 + 210 * k} ${220 + 16 * k})`), id))) return;
        if (!(await tween(160, (_, k) => usb.setAttribute('transform', `translate(${280 + 4 * Math.sin(Math.PI * k)} 236)`), id))) return;
        led(main, true);
        if (!(await wait(250, id))) return;
        mark(2);
        if (!(await scanIn(main, id))) return;
        mark(3);
      },
      async app(id) {
        mark(0);
        if (!(await rise(app, [70, 52], id))) return;
        mark(1);
        waves.classList.add('pulse');
        led(main, true);
        if (!(await wait(1100, id))) return;
        mark(2);
        await Promise.all([press(id), ripple(120, 170, id)]);
        const c = card();
        if (!(await fly(c, [141, 109], [280, 20], [420, 140], 950, id, 1.4))) return;
        c.remove();
        if (!(await scanIn(main, id))) return;
        waves.classList.remove('pulse');
        mark(3);
      },
      async pc(id) {
        mark(0);
        if (!(await rise(pc, [40, 150], id))) return;
        if (!(await moveCursor([250, 286], [104, 190], 550, id))) return;
        mark(1);
        waves.classList.add('pulse');
        led(main, true);
        if (!(await wait(750, id))) return;
        mark(2);
        if (!(await moveCursor([104, 190], [115, 210], 300, id))) return;
        await ripple(115, 211, id);
        cursor.style.display = 'none';
        const c = card();
        if (!(await fly(c, [101, 184], [280, 50], [420, 140], 950, id, 1.4))) return;
        c.remove();
        if (!(await scanIn(main, id))) return;
        waves.classList.remove('pulse');
        mark(3);
      },
      async cloud(id) {
        mark(0);
        if (!(await moveCursor([250, 286], [94, 219], 650, id))) return;
        await ripple(94, 219, id);
        cursor.style.display = 'none';
        mark(1);
        const c = card();
        if (!(await fly(c, [94, 190], [130, 70], [257, 66], 850, id, 0))) return;
        c.remove();
        await tween(360, (_, k) => arrow.setAttribute('transform', `translate(0 ${-5 * Math.sin(Math.PI * k)})`), id);
        screens.forEach((g) => led(g, true));
        mark(2);
        const targets = [[sideL, [329, 191]], [main, [420, 140]], [sideR, [487, 191]]];
        const flights = targets.map(([g, to], i) => wait(i * 140, id).then(async (ok) => {
          if (!ok) return false;
          const cc = card();
          const done = await fly(cc, [257, 66], [(257 + to[0]) / 2, 30], to, 800, id, 0.6);
          cc.remove();
          return done && scanIn(g, id);
        }));
        const res = await Promise.all(flights);
        if (res.every(Boolean)) mark(3);
      },
    };

    let current = FIRST;
    function show(key, animate) {
      current = key;
      const id = ++run;
      cards.replaceChildren(); fx.replaceChildren();
      tabs.forEach((t) => {
        const on = t.dataset.way === key;
        t.setAttribute('aria-selected', on);
        t.tabIndex = on ? 0 : -1;
      });
      $('wayPanel').setAttribute('aria-labelledby', 'way-' + key);
      // Überschrift nennt den gewählten Weg: Vom Handy, Vom PC, Vom USB-Stick ...
      const head = $('wayHead'), tab = tabs.find((t) => t.dataset.way === key);
      if (head && tab && tab.dataset.head && head.textContent !== tab.dataset.head) {
        head.classList.add('is-swap');
        setTimeout(() => { head.textContent = tab.dataset.head; head.classList.remove('is-swap'); }, animate === false ? 0 : 160);
      }
      $('wayHint').textContent = WAYS[key].hint;
      $('waySteps').innerHTML = WAYS[key].steps.map((t) => '<li>' + t + '</li>').join('');
      usb.style.display = key === 'usb' ? '' : 'none';
      app.style.display = key === 'app' ? '' : 'none';
      pc.style.display = key === 'pc' ? '' : 'none';
      waves.style.display = key === 'app' || key === 'pc' ? '' : 'none';
      cloud.style.display = sideL.style.display = sideR.style.display = key === 'cloud' ? '' : 'none';
      waves.classList.remove('pulse');
      cursor.style.display = 'none';
      send.removeAttribute('transform'); arrow.removeAttribute('transform');
      app.setAttribute('transform', 'translate(70 52)'); app.setAttribute('opacity', 1);
      pc.setAttribute('transform', 'translate(40 150)'); pc.setAttribute('opacity', 1);
      usb.setAttribute('transform', animate ? 'translate(70 220)' : 'translate(280 236)');
      screens.forEach((g) => { setB(g, animate ? 0 : 1); led(g, !animate); });
      replay.classList.remove('show');
      if (!animate) return;
      (PLAY[key] || (async () => {}))(id).then(() => { if (id === run) replay.classList.add('show'); });
    }

    tabs.forEach((t) => t.addEventListener('click', () => show(t.dataset.way, !reduceMotion)));
    replay.addEventListener('click', () => show(current, true));
    $('wayPanel').previousElementSibling.addEventListener('keydown', (e) => {
      const i = tabs.findIndex((t) => t.getAttribute('aria-selected') === 'true');
      const j = e.key === 'ArrowRight' ? (i + 1) % tabs.length : e.key === 'ArrowLeft' ? (i + tabs.length - 1) % tabs.length : -1;
      if (j < 0) return;
      e.preventDefault();
      tabs[j].focus();
      show(tabs[j].dataset.way, !reduceMotion);
    });

    if (reduceMotion) { show(FIRST, false); return; }
    // Ausgangslage zeigen, abgespielt wird erst, wenn der Abschnitt im Bild ist
    show(FIRST, false);
    screens.forEach((g) => { setB(g, 0); led(g, false); });
    usb.setAttribute('transform', 'translate(70 220)');
    new IntersectionObserver(([e], obs) => {
      if (e.isIntersecting) { show(current, true); obs.disconnect(); }
    }, { threshold: 0.5 }).observe(svg);
  })();

  // Einstieg: ein Display schaltet sich ein, beim Scrollen kommen weitere dazu, bis die Wand steht
  (() => {
    const svg = $('storySvg');
    const storySec = $('start');
    if (!svg || !storySec) return;
    const U = 50, X = 90, SY = 36, SH = 200, GY = 250, N = 8;
    const bodies = $('sBodies'), ovl = $('sOverlays'), seams = $('sSeams');
    const units = [], overlays = [];
    for (let k = 0; k < N; k++) {
      const g = document.createElementNS(svgNS, 'g');
      g.innerHTML =
        `<rect x="-0.6" y="${SY - 1.5}" width="${U + 1.2}" height="${SH + 3}" fill="#0b0b0d" stroke="#26262b" stroke-width=".6"/>` +
        `<rect x="21" y="${SY + SH + 1.5}" width="8" height="4" fill="#202024"/>` +
        `<rect x="-3" y="${SY + SH + 5}" width="${U + 6}" height="6.5" rx="2" fill="#18181b"/>` +
        `<circle cx="5" cy="${GY - 3.6}" r="3.6" fill="#1d1d21"/><rect x="2.5" y="${GY - 8.4}" width="5" height="2" rx=".6" fill="#b3202a"/>` +
        `<circle cx="${U - 5}" cy="${GY - 3.6}" r="3.6" fill="#1d1d21"/><rect x="${U - 7.5}" y="${GY - 8.4}" width="5" height="2" rx=".6" fill="#b3202a"/>`;
      bodies.appendChild(g); units.push(g);
      const o = document.createElementNS(svgNS, 'g');
      // Einschalten wie ein echtes Display: ganze Fläche schwarz, wird hell, dabei leuchtet der Rand kurz auf
      o.innerHTML = `<rect x="0" y="${SY}" width="${U}" height="${SH}" fill="#0b0b0d"/>` +
        `<rect x="1" y="${SY + 1}" width="${U - 2}" height="${SH - 2}" fill="none" stroke="#ffd6ec" stroke-width="2.4" filter="url(#sEdge)"/>`;
      ovl.appendChild(o); overlays.push(o);
    }

    const clamp01 = (v) => Math.max(0, Math.min(1, v));
    const seg = (p, a, b) => clamp01((p - a) / (b - a));
    const ease = (t) => (t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2);
    const lerp = (a, b, t) => a + (b - a) * t;
    // Helligkeit beim Einschalten: kurz dunkel, dann schnell hell und weich auslaufend
    const powerOn = (l) => { const t = clamp01((l - 0.08) / 0.92); return 1 - Math.pow(1 - t, 3); };
    // Zeitplan: das zweite Display kommt gleich beim ersten Scrollen, danach die Wand bis 8
    const arriveAt = (k, p) => (k === 0 ? 1 : k === 1 ? seg(p, 0.02, 0.16) : seg(p, 0.36 + 0.042 * (k - 2), 0.43 + 0.042 * (k - 2)));
    // Ab diesem Fortschritt schaltet sich ein Display ein. Das Hellwerden läuft dann in eigener Zeit,
    // unabhängig davon, wie schnell gescrollt wird. Beim Zurückscrollen geht es wieder aus.
    const switchAt = (k) => (k === 1 ? 0.16 : 0.43 + 0.042 * (k - 2));
    const ON_MS = 600, onAt = new Array(N).fill(null);
    let again = false, queued = false;
    const lightAt = (k, p, l0, a) => {
      if (k === 0) return l0;
      if (a < 1 || p < switchAt(k)) { onAt[k] = null; return 0; }
      if (reduceMotion) return 1;
      const now = performance.now();
      if (onAt[k] === null) onAt[k] = now;
      const l = clamp01((now - onAt[k]) / ON_MS);
      if (l < 1) again = true;
      return l;
    };
    const sLines = [];
    for (let k = 1; k < N; k++) {
      const ln = document.createElementNS(svgNS, 'line');
      ln.setAttribute('x1', X + k * U); ln.setAttribute('x2', X + k * U);
      ln.setAttribute('y1', SY); ln.setAttribute('y2', SY + SH);
      ln.style.display = 'none';
      seams.appendChild(ln); sLines.push(ln);
    }

    let aspect = 1;
    const measure = () => { const r = svg.getBoundingClientRect(); aspect = r.width / Math.max(1, r.height); };
    const frame = (cx, h) => { const w = h * aspect; return [cx - w / 2, GY + h * 0.16 - h, w, h]; };

    let p = 0, l0 = reduceMotion ? 1 : 0;
    function render() {
      const F1 = frame(115, 300), F2 = frame(140, 320);
      const F8 = frame(258, Math.max(330, 560 / aspect));
      let f;
      if (p < 0.02) f = F1;
      else if (p < 0.16) f = F1.map((v, i) => lerp(v, F2[i], ease(seg(p, 0.02, 0.16))));
      else if (p < 0.33) f = F2;
      else f = F2.map((v, i) => lerp(v, F8[i], ease(seg(p, 0.33, 0.65))));
      svg.setAttribute('viewBox', f.map((v) => v.toFixed(2)).join(' '));

      let inPlace = 0, litW = 0;
      const lights = [];
      for (let k = 0; k < N; k++) {
        const a = arriveAt(k, p), l = lightAt(k, p, l0, a);
        const x = X + k * U + (1 - ease(a)) * 280;
        units[k].setAttribute('transform', `translate(${x.toFixed(2)} 0)`);
        units[k].setAttribute('opacity', clamp01(a * 4));
        if (a >= 1 && inPlace === k) inPlace++;
        const o = overlays[k];
        if (a >= 1 && l < 1) {
          o.style.display = '';
          o.setAttribute('transform', `translate(${X + k * U} 0)`);
          o.firstChild.setAttribute('opacity', (1 - powerOn(l)).toFixed(3));
          o.lastChild.setAttribute('opacity', (Math.sin(Math.PI * l) * 0.85).toFixed(3));
        } else o.style.display = 'none';
        if (a >= 1) litW += powerOn(l) * U;
        lights[k] = a >= 1 ? l : 0;
      }
      $('sClipRect').setAttribute('width', inPlace * U);
      sLines.forEach((ln, i) => {
        const k = i + 1;
        ln.style.display = k < inPlace ? '' : 'none';
        ln.classList.toggle('gone', lights[k] >= 1 && lights[k - 1] >= 1);
      });
      const W = Math.max(litW, U);
      let lw = Math.min(W * 0.62, 26 + W * 0.2), lh = lw * 1.5;
      if (lh > SH * 0.62) { lh = SH * 0.62; lw = lh / 1.5; }
      const logo = $('sLogo');
      logo.setAttribute('x', X + W / 2 - lw / 2); logo.setAttribute('y', SY + SH / 2 - lh / 2);
      logo.setAttribute('width', lw); logo.setAttribute('height', lh);
      // Farbverlauf spannt sich immer über die leuchtende Fläche, wie auf den Renderings
      const gr = $('sGrad');
      gr.setAttribute('x2', X + W); gr.setAttribute('y2', SY + SH);
      const fg = $('sFloorGlow');
      fg.setAttribute('cx', X + W / 2); fg.setAttribute('rx', W / 2 + 70);
      $('sPerson').setAttribute('opacity', seg(p, 0.43, 0.57));

      const step = p < 0.18 ? 0 : p < 0.37 ? 1 : 2;
      document.querySelector('.story-cue').classList.toggle('off', p > 0.02);
      document.querySelectorAll('.step').forEach((el) => el.classList.toggle('is-on', +el.dataset.step === step));
      if (again && !queued) { queued = true; requestAnimationFrame(() => { queued = false; render(); }); }
      again = false;
    }

    // Fortschritt 0 bis 1, ab dem ersten Pixel Scrollen. Die Bühne steht direkt unter der Kopfzeile
    // (top der story-pin), deshalb zählt diese Höhe mit, sonst passiert auf den ersten 84 px nichts.
    const pin = storySec.querySelector('.story-pin');
    const progress = () => {
      const r = storySec.getBoundingClientRect();
      const top = pin ? parseFloat(getComputedStyle(pin).top) || 0 : 0;
      const run = storySec.offsetHeight - innerHeight + top;
      return run > 0 ? clamp01((top - r.top) / run) : 0;
    };
    let ticking = false;
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => { ticking = false; p = progress(); render(); });
    };

    measure();
    if (reduceMotion) {
      p = 1; l0 = 1; render();
      svg.pauseAnimations();
      return;
    }
    p = progress(); render();
    addEventListener('scroll', onScroll, { passive: true });
    addEventListener('resize', () => { measure(); render(); });

    // Beim Laden schaltet sich das erste Display einmal ein
    const t0 = performance.now() + 450;
    const boot = (t) => {
      l0 = clamp01((t - t0) / 600);
      render();
      if (l0 < 1) requestAnimationFrame(boot);
    };
    requestAnimationFrame(boot);
  })();

  // Bestellknopf: erst sichtbar, wenn der Bestellknopf im Konfigurator nach oben aus dem Bild gescrollt ist.
  // Vorher steht der Preis in der Bühne und im Konfigurator selbst, eine dauernde Preisleiste wirkt wie ein Angebotsshop.
  const bar = $('buybar');
  if (bar && $('buy')) {
    let buyPassed = false, footVisible = false;
    const upd = () => bar.classList.toggle('show', buyPassed && !footVisible);
    const foot = document.querySelector('footer');
    if (foot) new IntersectionObserver(([e]) => { footVisible = e.isIntersecting; upd(); }).observe(foot);
    new IntersectionObserver(([e]) => { buyPassed = !e.isIntersecting && e.boundingClientRect.top < 0; upd(); }).observe($('buy'));
  } else if (bar) {
    bar.remove();
  }

  // Fotos der Einsatzorte bewegen sich beim Scrollen etwas langsamer als die Seite
  const pics = [...document.querySelectorAll('.use-card .pic img')];
  if (!reduceMotion && pics.length) {
    let pend = false;
    const drift = () => {
      pend = false;
      const vh = innerHeight;
      pics.forEach((img) => {
        const r = img.parentElement.getBoundingClientRect();
        if (r.bottom < -80 || r.top > vh + 80) return;
        const c = (r.top + r.height / 2 - vh / 2) / vh;
        img.style.transform = `translateY(${(c * -24).toFixed(1)}px) scale(1.1)`;
      });
    };
    addEventListener('scroll', () => { if (!pend) { pend = true; requestAnimationFrame(drift); } }, { passive: true });
    drift();
  }

  // Produktseite: Anzahl wählen, Preis nach Staffel, Gesamtpreis und Flightcases, Bestellen mit Cases im Warenkorb
  const pdBox = $('pdBuyBox');
  if (pdBox) {
    const key = pdBox.dataset.model, variant = pdBox.dataset.variant, base = +pdBox.dataset.price || 0;
    const t = tiersOf(key), q = $('pdQty');
    const special = (STAFFEL && STAFFEL.special) || '/pages/contact';
    const draw = (v) => {
      const k = Math.max(1, Math.min(QTY_MAX, v || 1));
      q.value = k;
      const unit = unitPrice(key, k, base);
      $('pdUnit').textContent = euro(unit);
      $('pdTotal').textContent = euro(k * unit);
      $('pdCalc').textContent = k + '\u00a0×\u00a0' + euro(unit);
      $('pdIncl').innerHTML = inclText(k)
        + 'Sie möchten für jedes Display ein eigenes Flightcase? <a href="' + special + '">Angebot anfragen</a>';
      const ctrl = needsController(key, k);
      const pc = $('pdCtrl');
      if (pc) { pc.hidden = !ctrl; pc.innerHTML = ctrl ? controllerHtml() : ''; }
      $('pdBuy').href = location.origin + '/cart/' + variant + ':' + k + caseCart(k);
      $('pdBuyText').textContent = (k === 1 ? '1 Display' : k + ' Displays') + ' bestellen';
      const pq = $('pdQuote');
      if (pq) pq.href = pq.href.replace(/anzahl=\d+/, 'anzahl=' + k);
      const box = $('pdTiers');
      if (t && box) box.innerHTML = t.map(([min, pr], i) => {
        const next = t[i + 1];
        const label = !next ? 'ab ' + min + ' Displays' : next[0] - 1 === min ? (min === 1 ? '1 Display' : min + ' Displays') : min + '–' + (next[0] - 1) + ' Displays';
        const on = k >= min && (!next || k < next[0]);
        return '<div' + (on ? ' class="on"' : '') + '><small>' + label + '</small><b>' + (i ? 'je ' : '') + euro(pr) + '</b></div>';
      }).join('');
      else if (box) box.hidden = true;
    };
    $('pdMinus').addEventListener('click', () => draw(+q.value - 1));
    $('pdPlus').addEventListener('click', () => draw(+q.value + 1));
    q.addEventListener('change', () => draw(parseInt(q.value, 10)));
    draw(1);
  }

  // Im Shopify-Editor: nach Änderungen an einem Abschnitt die Vorschau neu aufbauen
  if (designMode) {
    let t = 0;
    document.addEventListener('shopify:section:load', () => { clearTimeout(t); t = setTimeout(() => location.reload(), 300); });
  }
})();
